export default function (val) {
    return typeof val === "string";
}